function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Zoo",
  opacity: 0.5
}, /*#__PURE__*/React.createElement("g", {
  id: "Group 56760"
}, /*#__PURE__*/React.createElement("path", {
  id: "Subtract",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.6535 14.433H13.2179V13.2598H15.5642V12.0866H16.6955V10.9553H17.8687V6.3045H16.6955V5.17322H5.17319V8.65087H6.30447V9.78216H8.60894V10.9553H6.30447V12.0866H5.17319V9.78216H5.17302V12.0866H5.17319V17.9106H6.30447V19.0419H17.8687V15.5643H16.6955V14.4749H16.6954V14.4331H16.6535V14.433ZM5.17319 20.1732V19.0419H5.17302V20.1732H5.17319Z",
  fill: "none"
})));

var SvgZoo = function SvgZoo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgZoo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/zoo.fd6347e6.svg";
export { ForwardRef as ReactComponent };